module.exports = __webpack_public_path__ + "img/projects.e44faa6b.svg";